import { defineComponent as T, ref as y, computed as S, watch as p, createElementBlock as d, openBlock as l, normalizeStyle as b, normalizeClass as c, unref as i, createCommentVNode as o, createElementVNode as r, createStaticVNode as B, withDirectives as E, renderSlot as s, createVNode as P, vShow as C } from "vue";
import { useResizeObserver as I, useMediaQuery as w } from "@vueuse/core";
import { EDITOR_ID as $, DocumentClasses as u, EditorClasses as N } from "@scalar-org/css";
import V from "./components/PageNav.vue.js";
/* empty css                        */
import D from "./components/TableOfContents.vue.js";
const G = ["id"], z = {
  key: 0,
  class: "layout-header"
}, O = {
  key: 1,
  class: "layout-aside-content"
}, R = ["id"], x = { class: "layout-aside-right" }, L = { class: "layout-footer" }, F = /* @__PURE__ */ T({
  __name: "ApiGuide",
  props: {
    activePage: {},
    editorViewportId: {},
    showSidebar: { type: Boolean },
    footerBelowSidebar: { type: Boolean },
    sidebar: {},
    headings: {},
    isLoaded: { type: Boolean }
  },
  emits: ["goToNextPage", "goToPrevPage"],
  setup(t) {
    const m = t, g = y(0), f = y(null);
    I(f, (e) => {
      g.value = e[0].contentRect.height;
    });
    const h = w("(max-width: 1120px)"), n = w("(max-width: 1000px)"), k = S(() => `Guide / ${m.activePage?.title}`);
    return p(
      () => m.activePage?.uid,
      () => {
        const e = document.getElementById($);
        e && (e.scrollTop = 0);
      }
    ), (e, a) => (l(), d("main", {
      id: i($),
      ref_key: "documentEl",
      ref: f,
      class: c({
        [i(u).Document]: !0,
        "footer-below-sidebar": t.footerBelowSidebar,
        "hide-aside-right": i(h)
      }),
      style: b({ "--full-height": `${g.value}px` })
    }, [
      i(n) ? o("", !0) : (l(), d("div", z, [
        s(e.$slots, "header", {}, void 0, !0)
      ])),
      r("aside", {
        class: c(["layout-aside-left", i(u).Sidebar])
      }, [
        i(n) ? s(e.$slots, "mobile-header", {
          key: 0,
          label: k.value
        }, void 0, !0) : o("", !0),
        t.showSidebar || !i(n) ? (l(), d("div", O, [
          i(n) ? s(e.$slots, "header", { key: 0 }, void 0, !0) : o("", !0),
          s(e.$slots, "guide-sidebar", {}, void 0, !0)
        ])) : o("", !0)
      ], 2),
      a[2] || (a[2] = B('<div class="section-flare-guide" data-v-9774e508><div class="section-flare" data-v-9774e508><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div><div class="section-flare-item" data-v-9774e508></div></div></div>', 1)),
      t.activePage?.backgroundImage ? (l(), d("div", {
        key: 1,
        class: "layout-image",
        style: b(`background-image: url(${t.activePage.backgroundImage})`)
      }, null, 4)) : o("", !0),
      E(r("div", {
        class: c(["editor layout-content", i(N).Editor])
      }, [
        s(e.$slots, "editor-content", {}, void 0, !0),
        P(V, {
          activePage: t.activePage,
          sidebar: t.sidebar,
          onGoToNextPage: a[0] || (a[0] = (v) => e.$emit("goToNextPage", v)),
          onGoToPrevPage: a[1] || (a[1] = (v) => e.$emit("goToPrevPage", v))
        }, null, 8, ["activePage", "sidebar"]),
        r("div", {
          id: t.editorViewportId,
          class: "layout-content-viewport"
        }, null, 8, R)
      ], 2), [
        [C, t.isLoaded]
      ]),
      r("aside", x, [
        i(h) ? o("", !0) : (l(), d("div", {
          key: 0,
          class: c(["custom-scroll custom-scroll-self-contain-overflow", [i(u).TableOfContents]])
        }, [
          P(D, {
            headings: t.headings,
            pageTitle: t.activePage?.title || ""
          }, null, 8, ["headings", "pageTitle"])
        ], 2))
      ]),
      r("div", L, [
        s(e.$slots, "footer", {}, void 0, !0)
      ])
    ], 14, G));
  }
});
export {
  F as default
};
